export default __webpack_public_path__ + "static/media/orderbook.e019f2f6.svg";